import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=15b35743"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=15b35743&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b35743')) {
      api.createRecord('15b35743', component.options)
    } else {
      api.reload('15b35743', component.options)
    }
    module.hot.accept("./BaseIcon.vue?vue&type=template&id=15b35743", function () {
      api.rerender('15b35743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/BaseIcon.vue"
export default component.exports